import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import {
	DATA_TYPES,
	FONTS,
	MIN_ROWS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../../constants";
import { formatNumber } from "../../helpers/FormatNumber";
import Column from "../../MachineLearning/Column";
import Dataset from "../../MachineLearning/Dataset";
import gear from "../../media/redo.svg";
import gear_grey from "../../media/redo_grey.svg";
import { stateType, stateTypeF } from "../../state";
import { sleep } from "../Common/helpers";
import { makeHistData } from "../Common/makeHistData";
import { HelpIcon } from "../Common/ToolTipIcon";
import { asyncApplyFiltersToDash } from "../DataIngestion/DropZoneBox";
import { applyFiltersToData, areDropRowsSame, areFiltersSame } from "./filters";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		text: {
			fontFamily: FONTS,
			height: "40px",
			marginLeft: "30px",
			marginTop: "10px",
			marginRight: "10px",
			cursor: "pointer",
			transition: "0.2s",
			"&:hover": { transform: "scale(1.03)" },
		},
		textDisabled: {
			fontFamily: FONTS,
			height: "40px",
			marginLeft: "30px",
			marginTop: "10px",
			marginRight: "10px",
			color: "#7a7979",
		},
	});
});

function Summary({ state }: stateType) {
	const classes = useStyles();
	const isAuto = areFiltersSame(
		state.saveState.cleanData.cleanDataFiltersApplied,
		state.saveState.cleanData.autoFilters
	);
	const nModified = Object.keys(
		state.saveState.cleanData.valuesModified
	).length;
	const nAllRowsDropped =
		state.saveState.dataset.data[
			Object.keys(state.saveState.dataset.data)[0]
		].length - state.saveState.dataset.columns[0].vectorizedData.length;
	return (
		<div
			style={{
				width: "500px",
				height: "100px",
				marginBottom: "0px",
				marginTop: "0px",
			}}
		>
			<div
				style={{
					marginRight: "auto",
					marginBottom: "10px",
					marginLeft: "0px",
					display: "flex",
					flexDirection: "row",
					fontFamily: FONTS,
				}}
			>
				<div
					style={{
						marginLeft: "5px",
						fontWeight: "bold",
						color: PRIMARY_COLOR,
					}}
				>
					{" "}
				</div>
			</div>
			<div
				style={{
					marginLeft: "0px",
					marginBottom: "7px",
					fontSize: "13px",
					color: "rgba(0,0,0,0.6)",
				}}
			>
				{" "}
			</div>
			<div
				style={{
					marginLeft: "0px",
					color: "rgba(0,0,0,0.6)",
					fontSize: "13px",
					marginBottom: "7px",
				}}
			>
				{" "}
			</div>
			<div
				style={{
					marginLeft: "0px",
					color: "rgba(0,0,0,0.6)",
					fontSize: "13px",
				}}
			>
				{" "}
			</div>
		</div>
	);
}

export function Buttons({ state }: stateType) {
	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				flexDirection: "row",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
				}}
			>
				<ApplyButton state={state}></ApplyButton>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginLeft: "-15px",
					}}
				></div>
			</div>
		</div>
	);
}

function RevertButton({ state }: stateType) {
	const classes = useStyles();
	function handleClick() {
		state.saveState.cleanData.cleanDataFilters = [
			...state.saveState.cleanData.cleanDataFiltersApplied,
		];
		state.saveState.cleanData.cleanRowsSelected =
			state.saveState.cleanData.cleanRowsSelectedApplied;
		state.setSaveState(state.saveState);
		let { data } = applyFiltersToData(
			state.saveState.dataset.data,
			state.saveState.cleanData.cleanHistSelected,
			state.saveState.cleanData.cleanDataFiltersApplied,
			state.saveState.cleanData.cleanRowsSelectedApplied,
			new Set()
		);
		let col = state.saveState.dataset.getColumn(
			state.saveState.cleanData.cleanHistSelected
		);
		let histData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelectedApplied,
			col.colStats.median
		);
		state.saveState.cleanData.cleanHistData = histData;
		state.setSaveState(state.saveState);
	}
	const isDisabled =
		areFiltersSame(
			state.saveState.cleanData.cleanDataFilters,
			state.saveState.cleanData.cleanDataFiltersApplied
		) &&
		areDropRowsSame(
			state.saveState.cleanData.cleanRowsSelected,
			state.saveState.cleanData.cleanRowsSelectedApplied
		);

	return (
		<div>
			<div
				color="primary"
				className={!isDisabled ? classes.text : classes.textDisabled}
				onClick={handleClick}
			>
				Revert
				<img
					style={{
						width: "17px",
						marginLeft: "5px",
						color: "white",
						marginTop: "3px",
						marginBottom: "-3px",
					}}
					src={!isDisabled ? gear : gear_grey}
				></img>
			</div>
		</div>
	);
}
export function resetCleanData(
	state: stateTypeF,
	dataset: Dataset,
	colName: string
) {
	let col = dataset.getColumn(colName);

	// Get filtered data

	state.saveState.cleanData.cleanHistData = undefined;
	state.setFilterSummary({ rowsModified: 0, rowsDropped: 0 });
	state.saveState.cleanData.cleanDataFilters = [];
	state.saveState.cleanData.cleanRowsSelected = new Set();
	state.saveState.cleanData.cleanHistSelected = col.columnName;
	state.setSaveState(state.saveState);
}
function getUsableColumn(dataset: Dataset) {
	let col: Column = undefined;
	for (let colv of dataset.columns) {
		if (
			colv.columnType === DATA_TYPES.number ||
			colv.columnType === DATA_TYPES.categorical
		) {
			col = colv;
			break;
		}
	}
	return col;
}

function ClearButton({ state }: stateType) {
	const classes = useStyles();
	function handleClick() {
		resetCleanData(
			state,
			state.saveState.dataset,
			state.saveState.cleanData.cleanHistSelected
		);
	}
	let isDisabled = state.saveState.cleanData.cleanDataFilters.length === 0;

	return (
		<div>
			<div
				className={isDisabled ? classes.textDisabled : classes.text}
				onClick={handleClick}
			>
				Clear All
			</div>
		</div>
	);
}

function ApplyButton({ state }: stateType) {
	async function handleApply() {
		state.setIsLoadingPopupOpen(true);
		await sleep(300);
		// Get filtered data
		let col = state.saveState.dataset.getColumn(
			state.saveState.cleanData.cleanHistSelected
		);
		let { data, rowsToDropFull } = applyFiltersToData(
			state.saveState.dataset.data,
			state.saveState.cleanData.cleanHistSelected,
			state.saveState.cleanData.cleanDataFilters,
			state.saveState.cleanData.cleanRowsSelected,
			state.saveState.cleanData.valuesModified
		);

		if (data.length < MIN_ROWS) {
			state.setRejectedReason(
				"Can't apply to dashboard, your dataset must have at least 50 rows of data."
			);
			state.setIsLoadingPopupOpen(false);
			state.setIsRejectedDropOpen(true);
			return;
		}
		let histData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelected,
			col.colStats.median
		);
		state.setReCalcSentTable(true);
		state.saveState.cleanData.cleanHistData = histData;
		state.setSaveState(state.saveState);

		let { returnedColumns, cors, valuesModified } =
			await asyncApplyFiltersToDash(
				state.saveState.dataset,
				state.saveState.cleanData.cleanDataFilters,
				state.saveState.cleanData.cleanRowsSelected,
				state
			);
		if (returnedColumns === undefined) {
			return;
		}
		let dataset = state.saveState.dataset;
		returnedColumns = returnedColumns.map((col) =>
			Object.assign(new Column(undefined, undefined), col)
		);
		dataset.columns = returnedColumns;
		state.saveState.correlations.correlations = cors;
		state.saveState.dataset = dataset;
		state.setIsLoadingPopupOpen(false);

		state.saveState.cleanData.cleanRowsSelectedApplied = {
			...state.saveState.cleanData.cleanRowsSelected,
		};
		const tmp = [...state.saveState.cleanData.cleanDataFilters].map((a) => {
			return { ...a };
		});

		state.saveState.cleanData.cleanDataFiltersApplied = tmp;
		state.saveState.cleanData.allRowsDropped = rowsToDropFull;
		state.saveState.cleanData.valuesModified = valuesModified;
		state.setSaveState(state.saveState, true);
	}
	const isDisabled =
		areFiltersSame(
			state.saveState.cleanData.cleanDataFilters,
			state.saveState.cleanData.cleanDataFiltersApplied
		) &&
		areDropRowsSame(
			state.saveState.cleanData.cleanRowsSelected,
			state.saveState.cleanData.cleanRowsSelectedApplied
		);

	return (
		<Button
			variant="contained"
			color="primary"
			disabled={isDisabled}
			onClick={handleApply}
			style={{
				fontFamily: FONTS,
				fontWeight: "bold",
				width: "200px",
				height: "40px",
				backgroundColor: SECONDARY_COLOR,
				color: isDisabled ? "rgba(255,255,255,0.6)" : "white",
			}}
		>
			Apply to Dash
		</Button>
	);
}

export function CleanHeader({ state }: stateType) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				zIndex: 1000,
				marginBottom: "-40px",
				marginTop: "20px",
			}}
		>
			<div
				style={{
					marginRight: "0px",
					marginLeft: "auto",
				}}
			>
				<Buttons state={state}></Buttons>
			</div>
		</div>
	);
}
